import React from 'react';
import Input from 'components/common/Input';
import { EventBus } from 'events/EventBus';
import { CanvasEvent } from 'events/EventTypes';
import styles from './index.module.scss';


export const WordExampleComponent = ({ object }) => {

  let wordExampleInfo = object.wordExampleInfo ? JSON.parse(object.wordExampleInfo) : { src: '', word: '' }

  const changeHandler = (infoType, value) => {
    wordExampleInfo[infoType] = value;
    EventBus.emit({ event: CanvasEvent.ModifyCanvasObjectPropertyEvent, payload: { object, property: "wordExampleInfo", value: JSON.stringify(wordExampleInfo) } });
  };

  return (
    <>
      <label>
        <input type="checkbox" onChange={e => changeHandler('isZhuyin', e.target.checked)} checked={wordExampleInfo.isZhuyin} />
        首冊
      </label>
      <Input className={styles.wordExampleInput} label="Src" value={wordExampleInfo.src} onChange={e => changeHandler('src', e.target.value)} />
      <Input className={styles.wordExampleInput} label="Word" value={wordExampleInfo.word} onChange={e => changeHandler('word', e.target.value)} />
    </>
  )
};